import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerInvoicesComponent } from './customer-invoices.component';

const routes: Routes = [
  { path: '', component: CustomerInvoicesComponent, data: { title: 'Invoices' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerInvoicesRoutingModule {}

@NgModule({
  imports: [
    CustomerInvoicesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerInvoicesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerInvoicesModule {}
